module.exports = __webpack_public_path__ + "img/collection-weddingRingsCertificate@2x.ea009fc.webp";